// src/utils/photoUpload.ts
// Reguły wspólne dla obu ścieżek uploadu. R7 z audytu backendu podnosi limit i dokłada HEIC/WebP —
// wtedy zmieniamy je tutaj, w jednym miejscu, zamiast osobno w każdej ścieżce.
import i18n from '../i18n';

export const MAX_PHOTO_SIZE_IN_MB = 1;

export const ACCEPTED_PHOTO_TYPES = ['image/jpeg', 'image/png'];

// Komunikat dla nauczyciela albo null, gdy plik przechodzi.
export const validatePhotoFile = (file: File): string | null => {
  if (!ACCEPTED_PHOTO_TYPES.includes(file.type)) {
    return i18n.t('words-list:images.badFormat');
  }

  if (file.size / 1024 / 1024 >= MAX_PHOTO_SIZE_IN_MB) {
    return i18n.t('words-list:images.tooBig', { mb: MAX_PHOTO_SIZE_IN_MB });
  }

  return null;
};

export const buildPhotoFormData = (file: File, wordsListId?: string): FormData => {
  const data = new FormData();
  data.set('file', file);

  const listId = wordsListId?.trim();
  if (listId) {
    data.set('wordsListId', listId);
  }

  return data;
};
